export async function transitYBIUseCase(year, month, client_id, shipping_service, yegoDashboardRepository) {
    const result = await yegoDashboardRepository.transitYBI(year, month, client_id, shipping_service);
    
    const info = await new yegoDashboardRepository.transit_model(result.data);

    if (!info.isValid()) {
        throw new Error("Transit Answer Inválido");
    }

    return result.data;
}